import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import {
  Space,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Select,
  Collapse,
  Row,
  Col,
  AutoComplete,
  Modal,
  Form,
  Tooltip,
  message,
  Pagination,
  Switch,
  Tabs,
  Tag,
  Spin,
  Avatar
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import ProductImg from '../../../assets/images/products.png'
import { useHistory, useParams } from 'react-router-dom'
import { faRecordVinyl } from '@fortawesome/free-solid-svg-icons'
import { cpuUsage } from 'process'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  getDecryptID,
  StringIsNullOrEmpty,
  updateProductIndexed
} from '../../../appRedux/actions/GlobalMethods'
import { PRODUCT_SCREEN } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { EditOutlined, UnorderedListOutlined } from '@ant-design/icons'
import BarCodeGenerator from '../../../components/ProductScreen/BarCodeGenerator'
// import { REACT_APP_BUS_FIRST_NAME } from '../../../constants/StoreSetting'
import ProductSearch from '../../../components/ProductSearch'
import { loadSearchSelectedProduct } from '../../../appRedux/actions'
import { env } from '../../../env'
import InventoryAdjustments from '../../../components/ProductScreen/InventoryAdjustments'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const { REACT_APP_BUS_FIRST_NAME } = env
const Panel = Collapse.Panel
const TabPane = Tabs.TabPane
const confirm = Modal.confirm
const DefaultStatus = 1
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const MainProduct = props => {
  const [form] = Form.useForm()
  const history = useHistory()
  const params = useParams()
  const dispatch = useDispatch()
  const [visible, setVisible] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [getProductListingData, setProductListingData] = React.useState([])
  const [pagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10
    // Status: DefaultStatus
  })

  const [productTypeOptions, setProductTypeOptions] = React.useState([
    { id: 1, label: '' }
  ])
  const [productTagOptions, setProductTagOptions] = React.useState([
    { id: 1, label: '' }
  ])
  const [supplierOptions, setSupplierOptions] = React.useState([
    { id: 1, label: '' }
  ])
  const [brandOptions, setBrandOptions] = React.useState([{ id: 1, label: '' }])
  const [options, setOptions] = useState([])
  const [getSearchProd, setSearchProd] = useState([])
  const [searchFilterData, setSearchFilterData] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10
  })
  const [tableDataOutletsInventory, setTableDataOutletsInventory] = useState()
  const [tableDataOutletsPrices, setTableDataOutletsPrices] = useState()
  const [productInventoryType, setProductInventoryType] = useState('0')
  const [tableProductCommonData, setTableProductCommonData] = useState()
  const [isSpinner, SetSpinner] = React.useState(true)
  const [TableProductVariantdata, setTableProductVariantdata] = useState([])
  const [expandedRowKeys, setExpandedRowKeys] = useState('')
  const [getTableCompositeProductData, setTableCompositeProductData] =
    React.useState([])
  const [OutletNameColumnVariant, setOutletNameColumnVariant] = useState([])
  const [OutletNameColumnVariantData, setOutletNameColumnVariantData] =
    useState([1, 2])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencyName: '',
    currencySymbol: ''
  })
  const [getDefaultDecimalPlaces, setDefaultDecimalPlace] = React.useState(2) //api me isko db sy update rakhna hy
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getDefaultOutletTaxes, setDefaultOutletTaxes] = useState([])
  const [getStoreOutletsOptions, setStoreOutletsOptions] = useState([])
  const [getVariantSKURows, setVariantSKURows] = React.useState([])

  const [OutletNameColumnComposite, setOutletNameColumnComposite] = useState([])
  const [OutletNameColumnCompositetData, setOutletNameColumnCompositetData] =
    useState([1, 2])
  const [DefaultCompositeData, setDefaultCompositeData] = React.useState([])
  const [DefaultCompositeOutletData, setDefaultCompositeOutletData] =
    React.useState([])
  const [DefaultCompositePriceData, setDefaultCompositePriceData] =
    React.useState([])
  const [saleTaxOptions, setSaleTaxOptions] = React.useState([
    { id: 1, label: '' }
  ])
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [getOutletName, setOutletName] = useState('')
  const [getRegName, setRegName] = useState('')
  const [getCurrProductID, setCurrProductID] = React.useState('')
  const [getSalesGroupTaxes, setSalesGroupTaxes] = useState([])
  const [showInvAdjustment, setShowInvAdjustment] = useState(false)
  const [invAdjData, setInvAdjData] = useState([])

  //#region  for use Selector

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const defaultSalesTaxID = useSelector(
    ({ MainSale }) => MainSale.defaultSalesTaxID
  )

  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  )
  //#endregion use Selector Region

  //#region  for use Effect

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(PRODUCT_SCREEN))
      getProductsData()
    }

    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      if (getSearchSelectedProduct) {
        onSelect(getSearchSelectedProduct)
      }
    }

    return () => (mounted = false)
  }, [getSearchSelectedProduct])
  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getReduxSelectedStoreOutlets.id) {
        setSelectedOutlet(getReduxSelectedStoreOutlets.id)
        setOutletName(
          getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.outlet
            ? getReduxSelectedStoreOutlets.outlet
            : ''
        )
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          setSelectedOutlet(
            getReduxSelectedStoreOutlets.id
              ? getReduxSelectedStoreOutlets.id
              : selectedLocalOut.id
          )
          setOutletName(
            selectedLocalOut && selectedLocalOut.outlet
              ? selectedLocalOut.outlet
              : ''
          )
        }
      }

      if (getReduxSelectedOutletReg.id) {
        setRegName(
          getReduxSelectedOutletReg && getReduxSelectedOutletReg.register
            ? getReduxSelectedOutletReg.register
            : ''
        )
      } else {
        let selectedReg = localStorage.getItem('selectedReg')
        if (selectedReg) {
          selectedReg = JSON.parse(selectedReg)
          setRegName(
            getReduxSelectedOutletReg.register
              ? getReduxSelectedOutletReg.register
              : selectedReg.register
          )
        }
      }

      return () => (mounted = false)
      // //;
    }
  }, [getReduxSelectedStoreOutlets, getReduxSelectedOutletReg])
  React.useEffect(() => {
    getProductsData()
  }, [defaultSalesTaxID])
  //for common data -> store currency
  // React.useEffect(() => {
  //   let commonData = getReduxCommonSetting;
  //   if (
  //     commonData.storeCommonConfigs &&
  //     commonData.storeCommonConfigs.storeConfig &&
  //     commonData.storeCommonConfigs.storeConfig.currencyData
  //   ) {
  //     let currencyData = commonData.storeCommonConfigs.storeConfig.currencyData;
  //     // setCurrSymbol(currencyData.currencySymbol);
  //     // setShortCurr(currencyData.currencyCode);
  //     setCurrData(currencyData);
  //   }
  // }, [getReduxCommonSetting]);

  //#endregion for use Effect

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function getRandomInt (max, min = 0) {
    return Math.floor(Math.random() * (max - min + 1)) + min // eslint-disable-line no-mixed-operators
  }

  async function getProductsData () {
    const getProductData = ds.getProductsData('', BEHAVIOUR_TYPE.GET)
    await getProductData.then(response => {
      let productCommonData = null
      if (response && response.data && response.data.data) {
        productCommonData = response.data.data
        setProductTypeOptions(productCommonData.productTypesOptions)
        setProductTagOptions(productCommonData.productTagsOptions)
        setSupplierOptions(productCommonData.suppliersOptions)
        setBrandOptions(productCommonData.brandsOptions)
        setSaleTaxOptions(productCommonData.salesTaxesOptions)
        setSalesGroupTaxes(productCommonData.salesGroupTaxes)
      }

      if (props.match.params.searchID) {
        let tagIDs = []
        let brandID = 0
        let supplierID = 0
        let typeID = 0

        let a = props.match.params.searchID
        if (a && a.includes('tagid')) {
          let TagID = getDecryptID(history.location.pathname.split('/')[6]) // groupId.substring(0, groupId.indexOf("&"));
          tagIDs.push(parseFloat(TagID))
          if (tagIDs != 0) {
            form.setFieldsValue({ ProductTags: tagIDs })
          }
        } else if (a && a.includes('brandid')) {
          brandID = parseFloat(
            getDecryptID(history.location.pathname.split('/')[6])
          )
          form.setFieldsValue({ BrandID: brandID })
        } else if (a && a.includes('supplierid')) {
          supplierID = parseFloat(
            getDecryptID(history.location.pathname.split('/')[6])
          )
          form.setFieldsValue({ SupplierID: supplierID })
        } else if (a && a.includes('typeid')) {
          typeID = parseFloat(
            getDecryptID(history.location.pathname.split('/')[6])
          )
          form.setFieldsValue({ ProductType: typeID })
        }
        let productTags =
          tagIDs &&
          tagIDs.map(obj => {
            return {
              key: obj.toString()
            }
          })
        // searchFilterData.status
        var searchObj = {
          ProductSearchText: '',
          ProductTags: productTags,
          Status: form.getFieldValue('ProductStatus')
            ? parseInt(form.getFieldValue('ProductStatus'))
            : DefaultStatus,
          BrandID: brandID,
          SupplierID: supplierID,
          ProductType: typeID,
          CurrentPageNo: pagination.CurrentPageNo,
          PageSize: pagination.PageSize
        }
        getProductListing(
          searchObj,
          productCommonData ? productCommonData.salesTaxesOptions : {},
          productCommonData ? productCommonData.salesGroupTaxes : {}
        )
        setSearchFilterData(searchObj)
      } else {
        getProductListing(
          pagination,
          productCommonData ? productCommonData.salesTaxesOptions : {},
          productCommonData ? productCommonData.salesGroupTaxes : {}
        )
      }

      // setSaleTaxOptions(productCommonData.salesTaxesOptions);
      // setVariantAttributeOptions(productCommonData.variantAttributesOptions);
    })
  }

  async function getProductsDetailsRowData (expanded, record) {
    var keys = []
    if (expanded) {
      keys.push(record.key) // I have set my record.id as row key. Check the documentation for more details.
    }
    SetSpinner(true)
    setTableProductCommonData([])
    setTableDataOutletsPrices([])
    setTableDataOutletsInventory([])
    setTableProductVariantdata([])
    setTableCompositeProductData([])
    let productID = record.key
    await ds
      .getProductCommonDetailByProductID(
        { productID: productID },
        BEHAVIOUR_TYPE.GET
      )
      .then(res => {
        if (res.data.msgCode == 'GENERAL_SUCCESS') {
          if (res.data.data.productDetails != null) {
            let productCommonData = res.data.data.productDetails
            let productName = productCommonData.productName
            setTableProductCommonData(productCommonData)
            let mapped = productCommonData.outletInventoriesandTax.map(
              storeOutlet => {
                return {
                  key: getRandomInt(100000000),
                  OutletID: storeOutlet.outletID,
                  OutletName: storeOutlet.outletName,
                  CurrentInventory: storeOutlet.currentInventory
                }
              }
            )
            //mapped.sort((a, b) => (a.name > b.name ? 1 : -1));
            let supplyPrice =
              productCommonData.supplyPrice != undefined
                ? parseFloat(productCommonData.supplyPrice).toFixed(
                    getDefaultDecimalPlaces
                  )
                : '0.00'
            let retailPrice =
              productCommonData.retailPrice != undefined
                ? parseFloat(productCommonData.retailPrice)
                : parseFloat(0).toFixed(getDefaultDecimalPlaces)

            let mappedPrices = productCommonData.outletInventoriesandTax.map(
              storeOutlet => {
                let taxObj = productRowTaxCalculator(
                  storeOutlet.taxID,
                  retailPrice,
                  saleTaxOptions,
                  getSalesGroupTaxes
                )
                return {
                  key: getRandomInt(100000000),
                  OutletID: storeOutlet.outletID,
                  OutletName: storeOutlet.outletName,
                  SupplyPrice: supplyPrice,
                  RetailPrice: retailPrice,
                  TaxPrice: taxObj.taxPrice
                }
              }
            )

            mapped.sort((a, b) => (a.name > b.name ? 1 : -1))
            setTableDataOutletsInventory(mapped)
            setTableDataOutletsPrices(mappedPrices)
            invAdjustmentProdData('0', mapped)

            if (productCommonData.productInventoryType == 'Standard Product') {
              SetSpinner(false)
              setProductInventoryType('0')
            }
            if (
              productCommonData.productInventoryType == 'Product with Variants'
            ) {
              setProductInventoryType('1')
            }
            if (productCommonData.productInventoryType == 'Composite Product') {
              setProductInventoryType('2')
            }

            if (res.data.msgCode == 'GENERAL_SUCCESS') {
              if (
                res.data.data.productDetails.productInventoryType !=
                'Standard Product'
              ) {
                ds.getProductOtherDetailByProductID(
                  {
                    productID: productID,
                    isThumbnailImage: true
                  },
                  BEHAVIOUR_TYPE.GET
                ).then(res1 => {
                  if (res1.data.msgCode == 'GENERAL_SUCCESS') {
                    if (res1.data.data.productDetails != null) {
                      let productOtherData = res1.data.data.productDetails

                      if (
                        productOtherData.productInventoryType ==
                        'Composite Product'
                      ) {
                        if (
                          productOtherData.compositeProductsData != null &&
                          productOtherData.compositeProductsData.length > 0
                        ) {
                          let compositeData =
                            productOtherData.compositeProductsData
                          let newCompositeData = compositeData.map(obj => {
                            let selectedTaxID = ''
                            let taxObj =
                              obj.productOutletTaxes &&
                              obj.productOutletTaxes.filter(
                                x =>
                                  getDecryptID(x.outletID) ==
                                  getDecryptID(getSelectedOutlet)
                              )
                            if (taxObj.length > 0) {
                              selectedTaxID = taxObj[0].taxID
                                ? taxObj[0].taxID
                                : '0'
                            } else {
                              selectedTaxID =
                                obj.productOutletTaxes[0] &&
                                obj.productOutletTaxes[0].taxID
                                  ? obj.productOutletTaxes[0].taxID
                                  : '0'
                            }
                            let rowTaxObj = productRowTaxCalculator(
                              getDecryptID(selectedTaxID),
                              obj.retailPrice,
                              saleTaxOptions,
                              getSalesGroupTaxes
                            )
                            return {
                              key: getRandomInt(1000000000000000),
                              ProductID: obj.productID,
                              ProductName: obj.productName,
                              CompositeProductQuantity: obj.quantity,
                              SupplyPrice:
                                obj.supplyPrice != undefined
                                  ? parseFloat(obj.supplyPrice).toFixed(
                                      getDefaultDecimalPlaces
                                    )
                                  : '0.00',
                              RetailPrice:
                                obj.retailPrice != undefined
                                  ? parseFloat(obj.retailPrice)
                                  : '0.00',
                              IsVariant: obj.isVariant,
                              VariantName: obj.variantName,
                              CompositeProductTaxPrice: rowTaxObj.taxPrice
                            }
                          })

                          setTableCompositeProductData(newCompositeData)
                          const compositeProductTaxes =
                            productOtherData.compositeProductsData[0] &&
                            productOtherData.compositeProductsData[0]
                              .compositeProductOutletTaxes

                          let compositeTaxID = ''
                          let taxObj =
                            compositeProductTaxes &&
                            compositeProductTaxes.filter(
                              x =>
                                getDecryptID(x.outletID) ==
                                getDecryptID(getSelectedOutlet)
                            )
                          if (taxObj.length > 0) {
                            compositeTaxID = taxObj[0].taxID
                              ? taxObj[0].taxID
                              : '0'
                          } else {
                            compositeTaxID =
                              compositeProductTaxes[0] &&
                              compositeProductTaxes[0].taxID
                                ? compositeProductTaxes[0].taxID
                                : '0'
                          }
                          let compositeTaxObj = productRowTaxCalculator(
                            getDecryptID(compositeTaxID),
                            productOtherData.compositeProductsData[0]
                              .compositeRetailPrice,
                            saleTaxOptions,
                            getSalesGroupTaxes
                          )

                          let CompositeDefaultPriceData = [
                            {
                              ProductName:
                                productOtherData.compositeProductsData[0]
                                  .compositeName,
                              SupplyPrice:
                                productOtherData.compositeProductsData[0]
                                  .compositeSupplyPrice,
                              RetailPrice:
                                productOtherData.compositeProductsData[0]
                                  .compositeRetailPrice,
                              TaxPrice: compositeTaxObj.taxPrice
                            }
                          ]
                          setDefaultCompositePriceData(
                            CompositeDefaultPriceData
                          )

                          // CalculateCompositeProductTotal(
                          //   newCompositeData
                          // );
                          let compositeInventoryData = []
                          productOtherData.compositeProductsData.forEach(
                            myCompositeFunction
                          )

                          function myCompositeFunction (item, index) {
                            let tempObj = {}
                            tempObj =
                              item.outletInventories &&
                              item.outletInventories.map(storeOutlet => {
                                return {
                                  key: getRandomInt(10000000000000),
                                  OutletID: storeOutlet.outletID,
                                  productID: storeOutlet.productID,
                                  currentInventory:
                                    storeOutlet.currentInventory,
                                  listingOutletName:
                                    storeOutlet.listingOutletName,
                                  listingProductName:
                                    storeOutlet.listingProductName,
                                  quantity: item.quantity
                                }
                              })
                            compositeInventoryData.push(tempObj)
                          }

                          let OutletNameColumComposite =
                            compositeInventoryData != null &&
                            compositeInventoryData[0] != null
                              ? compositeInventoryData[0].map(e => {
                                  return e != null
                                    ? e.listingOutletName != null
                                      ? e.listingOutletName.replace(/ /g, '')
                                      : ''
                                    : ''
                                })
                              : ''
                          let OutletNameCompositeInventoryData = []

                          if (compositeInventoryData != null) {
                            for (
                              let i = 0;
                              i <= compositeInventoryData.length - 1;
                              i++
                            ) {
                              let temp = compositeInventoryData[i]
                              let projObj =
                                temp &&
                                temp.map(e => {
                                  return {
                                    [e != null
                                      ? e.listingOutletName != null
                                        ? e.listingOutletName.replace(/ /g, '')
                                        : ''
                                      : '']: e.currentInventory
                                  }
                                })
                              OutletNameCompositeInventoryData.push(projObj)
                            }
                          }

                          let compositeTempObj = []
                          for (
                            let i = 0;
                            i <= OutletNameCompositeInventoryData.length - 1;
                            i++
                          ) {
                            let a = JSON.stringify(
                              OutletNameCompositeInventoryData[i]
                            )
                              .replace(/[{}]/g, '')
                              .replace(/[]/g, '{}')
                              .replace(/\[/g, '{')
                              .replace(/]/g, '}')
                              .replace(/"([^"]+(?="))"/g, '$1')
                              .replace(/(^"|"$)/g, '')
                              .replace(/[{}]/g, '')
                            //;
                            let properties = a.split(',')
                            let obj = {}
                            properties.forEach(function (property) {
                              let tup = property.split(':')
                              obj[tup[0]] = tup[1]
                            })
                            compositeTempObj.push(obj)
                          }
                          let OutletNameCompositeInventoryDataTotal = []

                          if (compositeInventoryData != null) {
                            for (
                              let i = 0;
                              i <= compositeInventoryData.length - 1;
                              i++
                            ) {
                              let temp = compositeInventoryData[i]
                              let projObj =
                                temp &&
                                temp.map(e => {
                                  return {
                                    [e != null
                                      ? e.listingOutletName != null
                                        ? e.listingOutletName.replace(/ /g, '')
                                        : ''
                                      : '']: e.currentInventory / e.quantity
                                  }
                                })
                              OutletNameCompositeInventoryDataTotal.push(
                                projObj
                              )
                            }
                          }
                          let compositeTempObjTotal = []
                          for (
                            let i = 0;
                            i <=
                            OutletNameCompositeInventoryDataTotal.length - 1;
                            i++
                          ) {
                            let a = JSON.stringify(
                              OutletNameCompositeInventoryDataTotal[i]
                            )
                              .replace(/[{}]/g, '')
                              .replace(/[]/g, '{}')
                              .replace(/\[/g, '{')
                              .replace(/]/g, '}')
                              .replace(/"([^"]+(?="))"/g, '$1')
                              .replace(/(^"|"$)/g, '')
                              .replace(/[{}]/g, '')
                            let properties = a.split(',')
                            let obj = {}
                            properties.forEach(function (property) {
                              let tup = property.split(':')
                              obj[tup[0]] = tup[1]
                            })
                            compositeTempObjTotal.push(obj)
                          }

                          setOutletNameColumnComposite(OutletNameColumComposite)
                          setOutletNameColumnCompositetData(compositeTempObj)
                          let DefaultCompositeData = [
                            {
                              key: getRandomInt(100000),
                              ProductName:
                                productOtherData.compositeProductsData[0]
                                  .compositeName
                            }
                          ]
                          //new work salis
                          setDefaultCompositeData(DefaultCompositeData)
                          let additionCompositeData = []
                          let inventoryCompositeValueArray = []
                          for (
                            let i = 0;
                            i < OutletNameColumComposite.length;
                            i++
                          ) {
                            if (compositeTempObjTotal[i]) {
                              inventoryCompositeValueArray.push(
                                Object.keys(compositeTempObjTotal[i]).map(k =>
                                  parseFloat(compositeTempObjTotal[i][k])
                                )
                              )
                            }
                          }
                          // let summationInventoryArray =
                          //   inventoryCompositeValueArray.reduce(function (
                          //     r,
                          //     a
                          //   ) {
                          //     a.forEach(function (b, i) {
                          //       r[i] = (r[i] || 0) + b;
                          //     });
                          //     return r;
                          //   },
                          //   []);
                          let summationInventoryArray =
                            inventoryCompositeValueArray.reduce(function (
                              r,
                              a
                            ) {
                              a.forEach(function (b, i) {
                                r[i] =
                                  r[i] === undefined || b < r[i]
                                    ? Math.floor(b)
                                    : Math.floor(r[i])
                              })
                              return r
                            },
                            [])
                          //console.log(summationInventoryArray);

                          for (
                            let i = 0;
                            i < OutletNameColumComposite.length;
                            i++
                          ) {
                            let obj = {
                              [OutletNameColumComposite[i]]:
                                summationInventoryArray[i]
                            }
                            additionCompositeData.push(obj)
                          }

                          let finalAdditionCompositeData = ''

                          for (
                            let i = 0;
                            i < additionCompositeData.length;
                            i++
                          ) {
                            finalAdditionCompositeData =
                              finalAdditionCompositeData +
                              ',' +
                              JSON.stringify(additionCompositeData[i])
                          }

                          let jsonParse =
                            '{' +
                            finalAdditionCompositeData
                              .replaceAll('{', '')
                              .replaceAll('}', '')
                              .replace(/(^,)|(,$)/g, '') +
                            '}'
                          jsonParse.replace(/['"]+/g, '')
                          let compositeDefaultData = [JSON.parse(jsonParse)]
                          setDefaultCompositeOutletData(compositeDefaultData)
                        }
                      }
                      if (
                        productOtherData.productInventoryType ==
                        'Product with Variants'
                      ) {
                        if (
                          productOtherData.productVariants != null &&
                          productOtherData.productVariants.length > 0
                        ) {
                          invAdjustmentProdData(
                            '1',
                            productOtherData.productVariants
                          )
                          let variantSKUs = []
                          productOtherData.productVariants.forEach(
                            getVariantSKUs
                          )
                          function getVariantSKUs (item, index) {
                            let skuObj = {}
                            skuObj = item.productSKUs.map(obj => {
                              return {
                                Key: index,
                                SKUID: obj.skuid,
                                SKUTypeID: parseInt(
                                  getDecryptID(obj.skuTypeID)
                                ),
                                SKUValue: obj.skuValue,
                                IsUnique: true,
                                RecordID: obj.recordID,
                                IsRemove: false
                              }
                            })
                            variantSKUs.push(skuObj)
                          }
                          setVariantSKURows(variantSKUs)
                          let variantColumnData =
                            productOtherData.productVariants.map(
                              (obj, index) => {
                                let selectedTaxID = ''
                                let taxObj =
                                  obj.outletInventoriesandTax &&
                                  obj.outletInventoriesandTax.filter(
                                    x =>
                                      getDecryptID(x.outletID) ==
                                      getDecryptID(getSelectedOutlet)
                                  )
                                if (taxObj.length > 0) {
                                  selectedTaxID = taxObj[0].taxID
                                    ? taxObj[0].taxID
                                    : '0'
                                } else {
                                  selectedTaxID =
                                    obj.outletInventoriesandTax[0] &&
                                    obj.outletInventoriesandTax[0].taxID
                                      ? obj.outletInventoriesandTax[0].taxID
                                      : '0'
                                }
                                let rowTaxObj = productRowTaxCalculator(
                                  selectedTaxID,
                                  obj.retailPrice,
                                  saleTaxOptions,
                                  getSalesGroupTaxes
                                )

                                return {
                                  key: index,
                                  VariantProductID: obj.productID,
                                  VariantName:
                                    productName + '/' + obj.variantName,
                                  VariantSupplierCode: obj.supplierCode,
                                  VariantSupplyPrice:
                                    obj.supplyPrice != undefined
                                      ? parseFloat(obj.supplyPrice).toFixed(
                                          getDefaultDecimalPlaces
                                        )
                                      : '0.00',
                                  VariantRetailPrice:
                                    obj.retailPrice != undefined
                                      ? parseFloat(obj.retailPrice)
                                      : parseFloat(0).toFixed(
                                          getDefaultDecimalPlaces
                                        ),
                                  ImageID: obj.productImages[0].id,
                                  // ImageURL:
                                  //   obj.productImages[0].imageURL.replace(
                                  //     "http://data.dakartest.com/",
                                  //     "http://localhost:13000/"
                                  //   ),
                                  ImageURL: obj.productImages[0].imageURL,
                                  VariantSKUs: variantSKUs[index],
                                  VariantTaxPrice: rowTaxObj.taxPrice
                                }
                              }
                            )

                          setTableProductVariantdata(variantColumnData)

                          let variantInventoryTaxData = []
                          let tempColumn = ['A', 'B', 'C', 'D', 'E']

                          productOtherData.productVariants.forEach(myFunction)
                          function myFunction (item, index) {
                            let tempObj = {}
                            tempObj = item.outletInventoriesandTax.map(
                              storeOutlet => {
                                return {
                                  key: getRandomInt(100000000),
                                  OutletID: storeOutlet.outletID,
                                  OutletName: storeOutlet.outletName,
                                  CurrentInventory: storeOutlet.currentInventory
                                }
                              }
                            )
                            variantInventoryTaxData.push(tempObj)
                          }

                          let OutletNameColumVariant =
                            variantInventoryTaxData != null &&
                            variantInventoryTaxData[0] != null
                              ? variantInventoryTaxData[0].map(e => {
                                  return e != null
                                    ? e.OutletName != null
                                      ? e.OutletName.replace(/ /g, '')
                                      : ''
                                    : ''
                                })
                              : ''
                          let OutletNameVariantInventoryData = []
                          if (variantInventoryTaxData != null) {
                            for (
                              let i = 0;
                              i <= variantInventoryTaxData.length - 1;
                              i++
                            ) {
                              let temp = variantInventoryTaxData[i]
                              let projObj =
                                temp &&
                                temp.map(e => {
                                  return {
                                    [e != null
                                      ? e.OutletName != null
                                        ? e.OutletName.replace(/ /g, '')
                                        : ''
                                      : '']: e.CurrentInventory
                                  }
                                })
                              OutletNameVariantInventoryData.push(projObj)
                            }
                          }
                          let temp1 = []
                          for (
                            let i = 0;
                            i <= OutletNameVariantInventoryData.length - 1;
                            i++
                          ) {
                            let a = JSON.stringify(
                              OutletNameVariantInventoryData[i]
                            )
                              .replace(/[{}]/g, '')
                              .replace(/[]/g, '{}')
                              .replace(/\[/g, '{')
                              .replace(/]/g, '}')
                              .replace(/"([^"]+(?="))"/g, '$1')
                              .replace(/(^"|"$)/g, '')
                              .replace(/[{}]/g, '')
                            //;
                            let properties = a.split(',')
                            let obj = {}
                            properties.forEach(function (property) {
                              let tup = property.split(':')
                              obj[tup[0]] = tup[1]
                            })
                            temp1.push(obj)
                          }
                          //  ;

                          setOutletNameColumnVariant(OutletNameColumVariant)
                          setOutletNameColumnVariantData(temp1)

                          // mapped.sort((a, b) => (a.name > b.name ? 1 : -1));
                          //   setTableDataVariantStoreOutlets(
                          //     variantInventoryTaxData
                          //   );
                        }
                      }

                      SetSpinner(false)
                    }
                  }
                })
              }
            }
          }
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
      })
  }

  function invAdjustmentProdData (type, data) {
    if (type && data && data.length > 0) {
      if (type == '0') {
        if (data && data.length > 0) {
          const outlets = []
          data.map(a => {
            const out = {
              currentInventory: a.CurrentInventory,
              outletID: a.OutletID,
              outletName: a.OutletName
            }
            outlets.push(out)
          })
          setInvAdjData([{ outletInventoriesandTax: outlets }])
        }
      } else if (type == '1') {
        if (data && data.length > 0) {
          setInvAdjData(data)
        }
      }
    }
  }

  function productRowTaxCalculator (
    selectedTaxID,
    retailPrice,
    salesTaxes,
    paramGroupSalesTaxes
  ) {
    let RetailPrice = parseFloat(retailPrice)
    let finalTax = 0
    let taxObj = {}
    if (selectedTaxID == '0') {
      //Default Tax Selected
      let obj =
        defaultSalesTaxID !== ''
          ? salesTaxes.filter(x => x.id == defaultSalesTaxID)[0]
          : salesTaxes[0]
      taxObj = {
        id: obj.id,
        label: obj.label,
        taxPercentage: obj.taxPercentage
      }
    } else {
      taxObj = salesTaxes.filter(x => x.id == selectedTaxID)[0]
    }
    const getTotalTaxDataPrice = GetCummulativeTaxDatabyTaxID(
      selectedTaxID,
      salesTaxes,
      paramGroupSalesTaxes
    )
    let taxPercentageValue = getTotalTaxDataPrice.totalTaxPercentage / 100
    //  RetailPrice += getTotalTaxDataPrice.totalFixedTax;
    finalTax = RetailPrice * taxPercentageValue
    finalTax += getTotalTaxDataPrice.totalFixedTax

    let displayPriceObj = {
      taxID: taxObj.id,
      taxName: taxObj.label,
      taxPrice: parseFloat(finalTax)
    }

    return displayPriceObj
  }

  async function getProductListing (
    searchObj,
    paramSalesTaxes,
    paramSalesGroupTaxes
  ) {
    await ds
      .getProductList(searchObj, BEHAVIOUR_TYPE.GET)
      .then(types => {
        setIsLoading(false)
        if (types.data.data != null) {
          const salesTaxes = paramSalesTaxes
          const groupTaxes = paramSalesGroupTaxes
          let mapped = types.data.data.map(product => {
            return {
              key: product.productID,
              productName: product.productName,
              brandID: product.brandID,
              brandName: product.brandName,
              supplierID: product.supplierID,
              supplierName: product.supplierName,
              totalInventoryCount: product.totalInventoryCount,
              retailPrice: getIsTaxExclusive
                ? product.retailPrice != undefined
                  ? parseFloat(product.retailPrice).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : '0.00'
                : DisplayPriceCalculator(
                    product.retailPrice,
                    product.productTaxID,
                    salesTaxes,
                    groupTaxes
                  ),
              isActive: product.isActive,
              createdOn: product.createdOn,
              ImageID: product.imageID,
              ImageURL: product.imageURL,
              taxPercentage: product.taxPercentage,
              taxName: product.taxName,
              taxID: product.taxID,
              productTaxID: product.productTaxID,
              isActiveOnSale: product.isActiveOnSale,
              isProductInventory: product.isProductInventory
            }
          })

          //  mapped.sort((a, b) => (a.productName > b.productName ? 1 : -1));
          setProductListingData(mapped)
          // ;
          if (types.data.data.length > 0) {
            let paginationobj = {
              CurrentPageNo: types.data.data[0].currentPageNo,
              PageSize: types.data.data[0].pageSize,
              total: types.data.data[0].totalRecords
            }
            setPagination(paginationobj)
          } else {
            setPagination({
              CurrentPageNo: 1,
              PageSize: 10
              // Status: DefaultStatus
            })
          }
        } else {
          setPagination({
            CurrentPageNo: 1,
            PageSize: 10
            // Status: DefaultStatus
          })
        }
      })
      .catch(e => {
        setIsLoading(false)
        setPagination({
          CurrentPageNo: 1,
          PageSize: 10
          // Status: DefaultStatus
        })
        notAllowMsgCheck(e)
      })
  }

  const GetCummulativeTaxDatabyTaxID = (
    paramTaxID,
    paramSalesTaxes,
    paramSalesGroupTaxes
  ) => {
    let taxID = paramTaxID.includes('&')
      ? getDecryptID(paramTaxID).toString()
      : paramTaxID.toString()
    if (taxID == '0') {
      taxID = defaultSalesTaxID
    }

    let totalTaxPercentage = 0
    let totalFixedTax = 0
    const currentTax =
      paramSalesTaxes && paramSalesTaxes.filter(x => x.id == taxID)[0]
    if (currentTax) {
      if (currentTax.isGroup) {
        const currentGroupTax =
          paramSalesGroupTaxes &&
          paramSalesGroupTaxes.filter(x => getDecryptID(x.groupID) == taxID)[0]
        if (currentGroupTax) {
          currentGroupTax.taxes &&
            currentGroupTax.taxes.map(x => {
              if (x.isFix) {
                totalFixedTax += x.salesTaxValue
              } else {
                totalTaxPercentage += x.salesTaxValue
              }
            })
        }
      } else {
        if (currentTax.isFix) {
          totalFixedTax = currentTax.taxPercentage
        } else {
          totalTaxPercentage = currentTax.taxPercentage
        }
      }
    }
    const totalTaxValue = {
      totalTaxPercentage: parseFloat(totalTaxPercentage),
      totalFixedTax: parseFloat(totalFixedTax)
    }
    return totalTaxValue
  }

  function DisplayPriceCalculator (
    retailPrice,
    productTaxID,
    pSalesTaxes,
    pSalesGroupTaxes
  ) {
    //ye function first outlet  k hisabs sy tax laga raha hy isko hamny globak settings sy krna parega,. like vnd jese krta hy inclusive prices k case me dropw down ajata hy geenral pr or wohe tax k hisabs sy calculations hoti hen
    let finalRetailPrice =
      retailPrice != null && retailPrice != undefined && retailPrice != ''
        ? parseFloat(retailPrice)
        : 0

    const getTotalTaxData = GetCummulativeTaxDatabyTaxID(
      productTaxID,
      pSalesTaxes,
      pSalesGroupTaxes
    )
    if (!getIsTaxExclusive) {
      if (finalRetailPrice != 0) {
        if (getTotalTaxData) {
          let totalTaxPercentage = getTotalTaxData.totalTaxPercentage / 100
          //  finalRetailPrice +=getTotalTaxData.totalFixedTax;
          let inclusiveRetailPrice =
            finalRetailPrice * totalTaxPercentage +
            finalRetailPrice +
            getTotalTaxData.totalFixedTax
          finalRetailPrice = parseFloat(inclusiveRetailPrice).toFixed(
            getDefaultDecimalPlaces
          )
        }
      }
    }
    return finalRetailPrice
  }

  async function postProductStatus (body) {
    //setLoader(true);
    await ds
      .postProductStatusData(body, BEHAVIOUR_TYPE.POST)
      .then(res => {
        if (res.data.data.isUpdated) {
          //setLoader(false);
          message.success(res.data.data.message)
          if (
            true
            // form.getFieldValue('ProductStatus') &&
            // form.getFieldValue('ProductStatus') != DefaultStatus
          ) {
            if (body.StatusType === 'IsActive') {
              // Remove the product with the given ProductID
              let tempProduct = getProductListingData.filter(
                x => x.key !== body.ProductID
              )
              setProductListingData(tempProduct)
            } else if (body.StatusType === 'IsActiveOnSale') {
              // Update the isActiveOnSale status of the product with the given ProductID
              let updatedProducts = getProductListingData.map(product => {
                if (product.key === body.ProductID) {
                  return { ...product, isActiveOnSale: body.ProductStatus }
                }
                return product
              })

              setProductListingData(updatedProducts)
            }
          } else {
            let tempProduct = [...getProductListingData]
            tempProduct.map(x => {
              if (x.key == body.ProductID) {
                x.isActive = body.ProductStatus == true ? true : false
              }
            })
            setProductListingData(tempProduct)
          }
        } else {
          message.error(res.data.data.message)
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        message.error('Something went wrong...')
      })
  }

  const redirectToadd = () => {
    history.push('/Dashboard/products/main/add')
  }

  const redirectToImport = () => {
    history.push('/Dashboard/products/main/import')
  }

  const handleTableChange = (pagination, filters, sorter) => {
    var searchObj = searchFilterData
    searchObj.CurrentPageNo = pagination.current
    searchObj.PageSize = pagination.pageSize
    setSearchFilterData(searchObj)
    getProductListing(searchObj, saleTaxOptions, getSalesGroupTaxes)
  }

  const handleSearch1 = async value => {
    if (value.length > 1) {
      let nameArray = []
      let searchProducts = {
        data: {
          msgCode: '',
          msgDescription: ''
        }
      }
      await ds
        .getBookSearchProd(`?keys=${value}`)
        .then(response => (searchProducts.data = response.data))
        .catch(e => {
          //console.log("Product Search Issue", e)
        })

      if (searchProducts.data.msgCode == 'GENERAL_SUCCESS') {
        if (searchProducts.data.data.length > 0) {
          setSearchProd(getSearchProd.concat(searchProducts.data.data))
          nameArray = searchProducts.data.data.map(names => {
            const category = names.productName
            return {
              value: category,
              label: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <span
                    style={{
                      backgroundColor: 'lightcyan',
                      fontStyle: 'oblique',
                      fontWeight: 'bolder'
                    }}
                  >
                    <a>{category}</a>
                  </span>
                  <span>
                    <IntlMessages id='products.addeditpriceprod.searchresult' />
                  </span>
                </div>
              )
            }
          })
        }

        setOptions(nameArray)
      }

      if (searchProducts.data.msgCode == 'GENERAL_ERROR') {
        message.error(searchProducts.data.msgDescription)
      }
    } else {
      setOptions([])
      setSearchProd([])
    }
  }

  // const handleSearch = (searchQuery) => {
  //   const request = window.indexedDB.open(INDEX_DB_NAME, 1);

  //   request.onerror = (event) => {
  //     console.error("IndexedDB error:", event.target.error);
  //   };

  //   request.onsuccess = (event) => {
  //     const db = request.result;
  //     const transaction = db.transaction("products", "readonly");

  //     const objectStore = transaction.objectStore("products");
  //     const searchIndex = objectStore.index("product_name"); // Replace with the appropriate index

  //     const results = [];
  //     searchIndex.openCursor().onsuccess = (event) => {
  //       const cursor = event.target.result;

  //       if (cursor) {
  //         const product = cursor.value;

  //         // Perform your search logic here
  //         if (
  //           product.productName
  //             .toLowerCase()
  //             .includes(searchQuery.toLowerCase())
  //         ) {
  //           results.push(product);
  //         }

  //         cursor.continue();
  //       } else {
  //         let nameArray = [];

  //         if (results.length > 0) {
  //           // setSearchProd(getSearchProd.concat(searchProducts.data.data));
  //           nameArray = results.map((names) => {
  //             const category = names.productName;
  //             return {
  //               value: category,
  //               label: (
  //                 <div
  //                   style={{
  //                     display: "flex",
  //                     justifyContent: "space-between",
  //                   }}
  //                 >
  //                   <span
  //                     style={{
  //                       backgroundColor: "lightcyan",
  //                       fontStyle: "oblique",
  //                       fontWeight: "bolder",
  //                     }}
  //                   >
  //                     <a>{category}</a>
  //                   </span>
  //                   <span>
  //                     <IntlMessages id="products.addeditpriceprod.searchresult" />
  //                   </span>
  //                 </div>
  //               ),
  //             };
  //           });
  //         }

  //         setOptions(nameArray);
  //         //setSearchResults(results);
  //       }
  //     };
  //   };
  // };

  const onSelect = selectedObj => {
    if (selectedObj && selectedObj != null) {
      if (selectedObj.isVariant) {
        if (selectedObj.parentProductID) {
          setCurrProductID(selectedObj.parentProductID.toString())
        } else {
          setCurrProductID('')
        }
      } else {
        if (selectedObj.productID) {
          setCurrProductID(selectedObj.productID.toString())
        } else {
          setCurrProductID('')
        }
      }
    } else {
      setCurrProductID('')
    }
  }

  const handleChageProductStatus = (status, productId, type) => {
    let body = {
      ProductID: productId,
      ProductStatus: status,
      StatusType: type
    }
    postProductStatus(body)
    if (type == 'IsActive') {
      updateProductIndexed({ key: getDecryptID(productId), isActive: status })
    }
    // updateProductIndexed({ key: getDecryptID(productId), isActiveOnSale : status })
  }

  const handleClearFields = () => {
    form.resetFields()
    setCurrProductID('')
    let paginationObj = {
      CurrentPageNo: 1,
      PageSize: 10
      // Status: DefaultStatus
    }
    setPagination(paginationObj)
    setSearchFilterData(paginationObj)
    getProductListing(paginationObj, saleTaxOptions, getSalesGroupTaxes)
    //history.push("/dashboard/products/main/listing/");
  }

  // columns ==> {
  //   title: <IntlMessages id="products.main.add.inventory" />,
  //   dataIndex: "totalInventoryCount",
  //   key: "totalInventoryCount",
  // },

  const columns = [
    {
      title: <IntlMessages id='products.main.add.product' />,
      dataIndex: 'productName',
      key: 'productName',
      render: (text, record) => {
        const url = `/dashboard/products/main/productdetail/${record.key}`
        return (
          <>
            <div
              onClick={() => history.push(url)}
              style={{ cursor: 'pointer' }}
              className='gx-module-list-icon'
            >
              <div className='sdf gx-d-sm-flex'>
                <Avatar
                  shape='square'
                  size={64}
                  alt={'salis'}
                  src={record.ImageURL}
                />
              </div>
              <div className='gx-ml-2  gx-d-sm-flex pro-na gx-link'>
                <span>{record.productName}</span>
                {/* <a
                  href={"/Dashboard/products/supplier/view/" + record.key}
                  className="gx-link"
                >
                  {record.productName}
                </a> */}
              </div>
            </div>
          </>
        )
      }
    },
    {
      title: <IntlMessages id='products.main.add.brand' />,
      dataIndex: 'brandName',
      key: 'brandName'
    },
    {
      title: <IntlMessages id='products.main.add.supplier' />,
      dataIndex: 'supplierName',
      key: 'supplierName'
    },

    {
      title: <IntlMessages id='products.main.add.retailprice' />,
      dataIndex: 'retailPrice',
      key: 'retailPrice',
      render: (text, record) => (
        <span>
          {getCurrData.currencyCode != null
            ? getCurrData.currencyCode
            : getCurrData.currencyName != null
            ? getCurrData.currencyName
            : getCurrData.currencySymbol}{' '}
          {parseFloat(record.retailPrice).toFixed(getDefaultDecimalPlaces)}{' '}
          {/* {!getIsTaxExclusive ? (
            record.taxName != "" ? (
              <span className="product-tax-font">
                {" "}
                Tax : ({record.taxName})
              </span>
            ) : (
              ""
            )
          ) : (
            ""
          )} */}
        </span>
      )
    },
    {
      title: <IntlMessages id='products.main.add.active' />,
      key: 'isActive',
      render: (text, record) => (
        <span>
          {' '}
          <Switch
            checked={record.isActive}
            onChange={e => showStatusConfirm(e, record, 'IsActive')}
            disabled={getIsDisableDelete}
          />
        </span>
      )
    },
    {
      title: <IntlMessages id='products.main.add.sellonpos' />,
      key: 'isActiveOnSale',
      render: (text, record) => (
        <span>
          {' '}
          <Switch
            checked={record.isActiveOnSale}
            onChange={e => showStatusConfirm(e, record, 'IsActiveOnSale')}
            disabled={getIsDisableDelete}
          />
        </span>
      )
    },
    {
      title: <IntlMessages id='products.main.add.createdon' />,
      dataIndex: 'createdOn',
      key: 'createdOn'
    },
    {
      title: <IntlMessages id='products.suppliers.edit' />,
      key: 'edit',
      render: (text, record) =>
        getIsDisableUpdate ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <span
            onClick={() => {
              history.push(`/Dashboard/products/main/edit/${record.key}`)
            }}
            className='pen-edit'
          >
            <i className='icon icon-edit'> </i>
          </span>
        )
    }
  ]

  const onFinish = value => {
    let productTags =
      value.ProductTags &&
      value.ProductTags.map(obj => {
        return {
          key: obj.toString()
        }
      })

    var searchObj = {
      ProductSearchText: StringIsNullOrEmpty(getCurrProductID)
        ? value.ProductSearch
        : '',
      ProductTags: productTags,
      Status: value.ProductStatus,
      BrandID: value.BrandID,
      SupplierID: value.SupplierID,
      ProductType: value.ProductType,
      ProductID: getCurrProductID,
      CurrentPageNo: 1,
      PageSize: 10
    }
    getProductListing(searchObj, saleTaxOptions, getSalesGroupTaxes)
    setSearchFilterData(searchObj)
    // console.log("Search Obj", searchObj);
  }

  function showStatusConfirm (e, record, type) {
    const action = e ? 'activate' : 'deactivate'
    const context = type === 'IsActive' ? '' : ' on sale'
    const title = `Are you sure you want to ${action} this product${context}?`

    confirm({
      title: title,
      content: `"${record.productName}"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        handleChageProductStatus(e, record.key, type)
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  function dialogAdjustmentClose () {
    setShowInvAdjustment(false)
    // setInvAdjData([])
  }

  const ExpandedRowRenderListing = props => {
    const productCommondData = tableProductCommonData
    const productVariantData = TableProductVariantdata
    let productVariants = []
    // console.log(productCommondData);
    if (productCommondData != null && productCommondData != undefined) {
      if (productCommondData.productInventoryType != undefined) {
        if (
          productCommondData.productInventoryType.toLowerCase() ===
          'product with variants'
        ) {
          productVariantData &&
            productVariantData.map(x => {
              let productVariantObj = {
                productID: x.VariantProductID,
                variantName: x.VariantName,
                retailPrice: x.VariantRetailPrice,
                imageURL: x.ImageURL,
                productSKU: x.VariantSKUs
              }
              productVariants.push(productVariantObj)
            })
        }
      }
    }
    let barcodeGenrationProducts = {
      productID: productCommondData.productID,
      productName: productCommondData.productName,
      productInventoryType: productCommondData.productInventoryType,
      imageURL:
        productCommondData.productImages != undefined &&
        productCommondData.productImages[0] != undefined
          ? productCommondData.productImages[0].imageURL
          : '',
      retailPrice: productCommondData.retailPrice,
      productSKU: productCommondData.productSKUs,
      productVariant: productVariants,
      productBatchesData: productCommondData.productBatchesDetails
    }
    // console.log(barcodeGenrationProducts);
    // console.log("productCommondData", productCommondData);
    // console.log("productVariants", productVariantData);
    return (
      <Row>
        <InventoryAdjustments
          data={invAdjData}
          prodInfo={!isEmptyObject(props.record) ? [props.record] : []}
          show={showInvAdjustment}
          onClose={dialogAdjustmentClose}
          prodType={productInventoryType}
          prodName={`${
            !isEmptyObject(props.record) && props.record.productName
              ? props.record.productName
              : ''
          }`}
        />
        <Col lg={16} md={14} sm={24} xs={24}>
          <Spin
            tip='Loading...'
            spinning={isSpinner}
            className='custom-spinner-bg'
          >
            <Tabs defaultActiveKey='1'>
              <TabPane
                tab={<IntlMessages id='products.main.add.inventory' />}
                key='1'
              >
                {productInventoryType == '0' ? (
                  <ExpandedRowRenderStandardInventory />
                ) : (
                  ''
                )}

                {productInventoryType == '1' ? (
                  <>
                    <Row>
                      <Col md={12} xs={12}>
                        <ExpandedRowRenderVariantInventoryTable1
                          record={props.record}
                        />
                      </Col>
                      <Col md={12} xs={12}>
                        <ExpandedRowRenderVariantInventoryTable2 />
                      </Col>
                    </Row>
                  </>
                ) : (
                  ''
                )}
                {productInventoryType == '2' ? (
                  <>
                    <Row>
                      <Col md={12} xs={12}>
                        <ExpandedRowRenderDefaultCompositeInventoryTable1 />
                      </Col>
                      <Col md={12} xs={12}>
                        <ExpandedRowRenderDefaultCompositeInventoryTable2 />
                      </Col>
                    </Row>

                    <p className='custom-font-weight-500 custom-font-color-black'>
                      <IntlMessages id='products.main.add.whatsintt' />
                    </p>
                    <Row>
                      <Col md={12} xs={12}>
                        <ExpandedRowRenderCompositeInventoryTable1
                          record={props.record}
                        />
                      </Col>
                      <Col md={12} xs={12}>
                        <ExpandedRowRenderCompositeInventoryTable2 />
                      </Col>
                    </Row>
                  </>
                ) : (
                  ''
                )}
              </TabPane>

              <TabPane
                tab={<IntlMessages id='products.main.listingtable.pricing' />}
                key='2'
              >
                {productInventoryType == '0' ? (
                  <ExpandedRowRenderStandardPrices />
                ) : (
                  ''
                )}

                {productInventoryType == '1' ? (
                  <ExpandedRowRenderVariantPricing record={props.record} />
                ) : (
                  ''
                )}
                {productInventoryType == '2' ? (
                  <>
                    <ExpandedRowRenderDefaultCompositeInventoryPrice />
                    <p className='custom-font-weight-500 custom-font-color-black dk-mt3'>
                      <IntlMessages id='products.main.add.whatsintt' />
                    </p>
                    <ExpandedRowRenderCompositeInventoryPrice />
                  </>
                ) : (
                  ''
                )}
              </TabPane>

              <TabPane
                tab={<IntlMessages id='products.main.listingtable.details' />}
                key='3'
              >
                <ExpandedRowRenderDetails />
              </TabPane>
            </Tabs>
          </Spin>
        </Col>
        <Col lg={8} md={10} sm={24} xs={24}>
          <div className='dk-expand-btn-mobile'>
            <Button
              className='dk-btn-edit-expand dk-wd-auto dk-hgt-50 edit-text-btn'
              onClick={() =>
                history.push(
                  `/Dashboard/products/main/edit/${props.record.key}`
                )
              }
              icon={<EditOutlined className='dk-btn-icon-align' />}
            >
              {<IntlMessages id='products.promotionlisting.edit' />}
            </Button>
            <BarCodeGenerator
              buttonType={'ProductExpand'}
              barcodeData={barcodeGenrationProducts}
              currencySymbol={
                getCurrData.currencyCode != null
                  ? getCurrData.currencyCode
                  : getCurrData.currencyName != null
                  ? getCurrData.currencyName
                  : getCurrData.currencySymbol
              }
            />

            <Button
              className='dk-btn-expand-view dk-mg-tp-20 dk-wd-auto dk-hgt-50 inventory-text-btn'
              onClick={() => {
                window.open(
                  `/dashboard/reporting/product-movements/${props.record.key}`
                )
              }}
              icon={<UnorderedListOutlined className='dk-btn-icon-align' />}
            >
              {
                <IntlMessages id='products.main.listingtable.viewinventorymovements' />
              }
            </Button>
            {props.record.isProductInventory &&
              productInventoryType &&
              productInventoryType != '2' && (
                <Button
                  className='dk-btn-expand-view dk-mg-tp-20 dk-wd-auto dk-hgt-50 inventory-text-btn'
                  onClick={() => setShowInvAdjustment(true)}
                  icon={<UnorderedListOutlined className='dk-btn-icon-align' />}
                >
                  Adjust Inventory
                </Button>
              )}
          </div>
        </Col>
      </Row>
    )
  }

  const ExpandedRowRenderStandardInventory = props => {
    const columnsInventoryRender = [
      {
        title: 'Outlet',
        dataIndex: 'OutletName',
        key: 'OutletName'
      },
      {
        title: 'Current Inventory',
        dataIndex: 'CurrentInventory',
        key: 'CurrentInventory'
      }
    ]
    return (
      <Table
        className='gx-table-responsive'
        columns={columnsInventoryRender}
        dataSource={tableDataOutletsInventory}
        pagination={false}
      />
    )
  }

  const ExpandedRowRenderStandardPrices = props => {
    const columnsPricesRender = [
      {
        title: 'Outlet',
        dataIndex: 'OutletName',
        key: 'OutletName'
      },
      {
        title: 'Supply Price',
        dataIndex: 'SupplyPrice',
        key: 'SupplyPrice',
        render: (text, record) => (
          <span>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}{' '}
            {record.SupplyPrice}
          </span>
        )
      },
      {
        title: 'Retail Price',
        dataIndex: 'RetailPrice',
        key: 'RetailPrice',
        render: (text, record) => (
          <span>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}{' '}
            {getIsTaxExclusive
              ? parseFloat(record.RetailPrice).toFixed(getDefaultDecimalPlaces)
              : (
                  parseFloat(record.RetailPrice) + parseFloat(record.TaxPrice)
                ).toFixed(getDefaultDecimalPlaces)}
          </span>
        )
      }
    ]
    return (
      <Table
        className='gx-table-responsive'
        columns={columnsPricesRender}
        dataSource={tableDataOutletsPrices}
        pagination={false}
      />
    )
  }

  const ExpandedRowRenderVariantPricing = props => {
    const columnsProductVariant = [
      {
        title: 'Products',
        dataIndex: 'VariantName',
        key: 'VariantName',
        render: (text, record) => (
          <>
            <div className='gx-module-list-icon'>
              <div className='sdf gx-d-sm-flex'>
                <Avatar
                  shape='square'
                  size={64}
                  alt={'salis'}
                  src={record.ImageURL}
                />
              </div>
              <div className='gx-ml-2 sdf gx-d-sm-flex'>
                <span
                  onClick={() => {
                    history.push(
                      `/dashboard/products/main/productdetail/${props.record.key}`
                    )
                  }}
                  className='gx-link'
                >
                  {record.VariantName}
                </span>
              </div>
            </div>
          </>
        )
      },
      {
        title: 'Supplier Code',
        dataIndex: 'VariantSupplierCode',
        key: 'VariantSupplierCode'
      },
      {
        title: 'Supply Price',
        dataIndex: 'VariantSupplyPrice',
        key: 'VariantSupplyPrice',
        render: (text, record) => (
          <span>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}{' '}
            {record.VariantSupplyPrice}
          </span>
        )
      },
      {
        title: 'Retail Price',
        dataIndex: 'VariantRetailPrice',
        key: 'VariantRetailPrice',
        render: (text, record) => (
          <span>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}{' '}
            {getIsTaxExclusive
              ? parseFloat(record.VariantRetailPrice).toFixed(
                  getDefaultDecimalPlaces
                )
              : (
                  parseFloat(record.VariantRetailPrice) +
                  parseFloat(record.VariantTaxPrice)
                ).toFixed(getDefaultDecimalPlaces)}
          </span>
        )
      }
    ]

    return (
      <Table
        className='gx-table-responsive'
        columns={columnsProductVariant}
        dataSource={TableProductVariantdata}
        pagination={false}
      />
    )
  }

  const ExpandedRowRenderVariantInventoryTable1 = props => {
    const columnsProductVariant = [
      {
        title: 'Products',
        dataIndex: 'VariantName',
        key: 'VariantName',
        render: (text, record) => (
          <>
            <div className='gx-module-list-icon'>
              <div className='sdf gx-d-sm-flex'>
                <Avatar
                  shape='square'
                  size={64}
                  alt={'salis'}
                  src={record.ImageURL}
                />
              </div>
              <div className='gx-ml-2  gx-d-sm-flex'>
                <a
                  onClick={() => {
                    history.push(
                      `/dashboard/products/main/productdetail/${props.record.key}`
                    )
                  }}
                  className='gx-link'
                >
                  {record.VariantName}
                </a>
              </div>
            </div>
          </>
        )
      }
    ]

    return (
      <Table
        className='gx-table-responsive'
        columns={columnsProductVariant}
        dataSource={TableProductVariantdata}
        pagination={false}
      />
    )
  }

  const ExpandedRowRenderVariantInventoryTable2 = props => {
    //;
    let DynamicColumn = {}
    let temp1 = OutletNameColumnVariant
    if (temp1 != '') {
      DynamicColumn =
        temp1 &&
        temp1.map(e => {
          return {
            title: e.toString(),
            dataIndex: e.toString(),
            key: e.toString()
          }
        })
    }
    const columnsProductVariant =
      DynamicColumn.length != undefined ? DynamicColumn : []

    return OutletNameColumnVariantData.length >= 1 &&
      columnsProductVariant.length >= 1 ? (
      <Table
        className='gx-table-responsive inventory-table'
        rowClassName={'inventory-table-row'}
        columns={columnsProductVariant}
        dataSource={OutletNameColumnVariantData}
        pagination={false}
      />
    ) : (
      ''
    )
  }

  const ExpandedRowRenderCompositeInventoryPrice = props => {
    const columnsCompositeProductPrice = [
      {
        title: <IntlMessages id='products.main.add.quantity' />,
        dataIndex: 'CompositeProductQuantity',
        key: 'CompositeProductQuantity'
      },
      {
        title: <IntlMessages id='products.main.add.product' />,
        dataIndex: 'ProductName',
        key: 'ProductName',
        render: (text, record) => (
          <>
            <div className='gx-module-list-icon'>
              <div className='sdf gx-d-sm-flex ss'>
                <Avatar
                  shape='square'
                  size={64}
                  alt={'salis'}
                  // src={record.ImageURL}
                />
              </div>
              <div className='gx-ml-2  gx-d-sm-flex'>
                <a
                  onClick={() => {
                    history.push(
                      `/dashboard/products/main/productdetail/${record.ProductID}`
                    )
                  }}
                  className='gx-link'
                >
                  {record.IsVariant
                    ? `${record.ProductName} ${record.VariantName}`
                    : record.ProductName}
                </a>
              </div>
            </div>
          </>
        )
      },

      {
        title: <IntlMessages id='products.main.add.supplyprice' />,
        dataIndex: 'SupplyPrice',
        key: 'SupplyPrice',
        render: (text, record) => (
          <span>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}{' '}
            {record.SupplyPrice}
          </span>
        )
      },
      {
        title: <IntlMessages id='products.main.add.retailprice' />,
        dataIndex: 'RetailPrice',
        key: 'RetailPrice',
        render: (text, record) => (
          <span>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}{' '}
            {getIsTaxExclusive
              ? parseFloat(record.RetailPrice).toFixed(getDefaultDecimalPlaces)
              : (
                  parseFloat(record.RetailPrice) +
                  parseFloat(record.CompositeProductTaxPrice)
                ).toFixed(getDefaultDecimalPlaces)}
          </span>
        )
      }
    ]
    return (
      <Table
        className='gx-table-responsive'
        pagination={false}
        columns={columnsCompositeProductPrice}
        dataSource={getTableCompositeProductData}
      />
    )
  }

  const ExpandedRowRenderDefaultCompositeInventoryTable1 = props => {
    // ProductID, Name, CompositeProductQuantity;
    const DefaultcolumnsProductComposite = [
      {
        title: <IntlMessages id='products.main.add.product' />,
        dataIndex: 'ProductName',
        key: 'ProductName',
        render: (text, record) => (
          <>
            <div className='gx-module-list-icon'>
              <div className='sdf gx-d-sm-flex'>
                <Avatar
                  shape='square'
                  size={64}
                  alt={'salis'}
                  // src={record.ImageURL}
                />
              </div>
              <div className='gx-ml-2  gx-d-sm-flex'>{record.ProductName}</div>
            </div>
          </>
        )
      }
    ]
    return (
      <Table
        className='gx-table-responsive'
        columns={DefaultcolumnsProductComposite}
        dataSource={DefaultCompositeData}
        pagination={false}
      />
    )
  }

  const ExpandedRowRenderDefaultCompositeInventoryPrice = () => {
    // ProductID, Name, CompositeProductQuantity;
    const DefaultcolumnsProductComposite = [
      {
        title: <IntlMessages id='products.main.add.product' />,
        dataIndex: 'ProductName',
        key: 'ProductName',
        render: (text, record) => (
          <>
            <div className='gx-module-list-icon'>
              <div className='sdf gx-d-sm-flex'>
                <Avatar
                  shape='square'
                  size={64}
                  alt={'salis'}
                  // src={record.ImageURL}
                />
              </div>
              <div className='gx-ml-2  gx-d-sm-flex'>{record.ProductName}</div>
            </div>
          </>
        )
      },
      {
        title: <IntlMessages id='products.main.add.supplyprice' />,
        dataIndex: 'SupplyPrice',
        key: 'SupplyPrice',
        render: (text, record) => (
          <span>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}{' '}
            {record.SupplyPrice}
          </span>
        )
      },
      {
        title: <IntlMessages id='products.main.add.retailprice' />,
        dataIndex: 'RetailPrice',
        key: 'RetailPrice',
        render: (text, record) => (
          <span>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}{' '}
            {getIsTaxExclusive
              ? parseFloat(record.RetailPrice).toFixed(getDefaultDecimalPlaces)
              : (
                  parseFloat(record.RetailPrice) + parseFloat(record.TaxPrice)
                ).toFixed(getDefaultDecimalPlaces)}
          </span>
        )
      }
    ]
    return (
      <Table
        className='gx-table-responsive'
        columns={DefaultcolumnsProductComposite}
        dataSource={DefaultCompositePriceData}
        pagination={false}
      />
    )
  }

  const ExpandedRowRenderDefaultCompositeInventoryTable2 = props => {
    //;
    let DynamicColumn = {}
    let temp1 = OutletNameColumnComposite

    if (temp1 != '') {
      DynamicColumn =
        temp1 &&
        temp1.map(e => {
          return {
            title: e.toString(),
            dataIndex: e.toString(),
            key: e.toString()
          }
        })
    }
    const columnsProductComposite =
      DynamicColumn.length != undefined ? DynamicColumn : []
    return OutletNameColumnVariantData.length >= 1 &&
      columnsProductComposite.length >= 1 ? (
      <Table
        className='gx-table-responsive inventory-table'
        rowClassName={'inventory-table-row'}
        columns={columnsProductComposite}
        dataSource={DefaultCompositeOutletData}
        pagination={false}
        // scroll={{ x: 1000 }}
      />
    ) : (
      ''
    )
  }

  const ExpandedRowRenderCompositeInventoryTable1 = props => {
    // ProductID, Name, CompositeProductQuantity;
    const columnsProductComposite = [
      {
        title: <IntlMessages id='products.main.add.quantity' />,
        dataIndex: 'CompositeProductQuantity',
        key: 'CompositeProductQuantity'
      },
      {
        title: <IntlMessages id='products.main.add.product' />,
        dataIndex: 'ProductName',
        key: 'ProductName',
        render: (text, record) => (
          <>
            <div className='gx-module-list-icon'>
              <div className='sdf gx-d-sm-flex'>
                <Avatar
                  shape='square'
                  size={64}
                  alt={'salis'}
                  // src={record.ImageURL}
                />
              </div>
              <div className='gx-ml-2  gx-d-sm-flex'>
                <a
                  onClick={() => {
                    history.push(
                      `/dashboard/products/main/productdetail/${record.ProductID}`
                    )
                  }}
                  className='gx-link'
                >
                  {record.IsVariant
                    ? `${record.ProductName} ${record.VariantName}`
                    : record.ProductName}
                </a>
              </div>
            </div>
          </>
        )
      }
    ]
    return (
      <Table
        className='gx-table-responsive'
        columns={columnsProductComposite}
        dataSource={getTableCompositeProductData}
        pagination={false}
      />
    )
  }

  const ExpandedRowRenderCompositeInventoryTable2 = props => {
    //;
    let DynamicColumn = {}
    let temp1 = OutletNameColumnComposite
    // console.log("temp1 col ", temp1);
    // console.log("OutletNameColumnCompositetData  ", temp1);

    if (temp1 != '') {
      DynamicColumn =
        temp1 &&
        temp1.map(e => {
          return {
            title: e.toString(),
            dataIndex: e.toString(),
            key: e.toString()
          }
        })
    }
    const columnsProductComposite =
      DynamicColumn.length != undefined ? DynamicColumn : []

    return OutletNameColumnVariantData.length >= 1 &&
      columnsProductComposite.length >= 1 ? (
      <Table
        rowClassName={'inventory-table-row'}
        columns={columnsProductComposite}
        dataSource={OutletNameColumnCompositetData}
        pagination={false}
        // scroll={{ x: 1000 }}
      />
    ) : (
      ''
    )
  }

  const ExpandedRowRenderDetails = props => {
    {
      return (
        <>
          <Row>
            <Col md={18}>
              <Row>
                <Col md={12}>
                  <div class='custom-div-wrap custom-mg-6'>
                    <h4 class='custom-font-weight-500'>
                      {' '}
                      <IntlMessages id='products.main.listingtable.type' />
                    </h4>
                    {!StringIsNullOrEmpty(
                      tableProductCommonData.productTypeName
                    )
                      ? tableProductCommonData.productTypeName
                      : '-'}
                  </div>
                  <div class='custom-div-wrap custom-mg-6'>
                    <h4 class='custom-font-weight-500'>
                      {' '}
                      <IntlMessages id='products.main.listingtable.description' />
                    </h4>
                    <div>
                      <span width='0'>
                        <span>
                          {!StringIsNullOrEmpty(
                            tableProductCommonData.description
                          ) ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: `${tableProductCommonData.description}`
                              }}
                            ></div>
                          ) : (
                            '-'
                          )}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class='custom-div-wrap'>
                    <div class='custom-display-flex  custom-flex--justify-between'>
                      <h4 class='custom-font-weight-500'>
                        {' '}
                        <IntlMessages id='products.main.listingtable.supplier' />
                      </h4>
                      <h4 class='custom-font-weight-500'>
                        {' '}
                        <IntlMessages id='products.main.listingtable.supplierprice' />
                      </h4>
                    </div>
                    <Divider />
                    <div class='custom-display-flex  custom-flex--justify-between'>
                      <div>
                        <p class='custom-text-content custom-mb-2'>
                          {!StringIsNullOrEmpty(
                            tableProductCommonData.supplierName
                          )
                            ? tableProductCommonData.supplierName
                            : '-'}
                        </p>
                        <p class='custom-addup-text'>
                          {!StringIsNullOrEmpty(
                            tableProductCommonData.supplierCode
                          )
                            ? tableProductCommonData.supplierCode
                            : '-'}
                        </p>
                      </div>
                      {getCurrData.currencyCode != null
                        ? getCurrData.currencyCode
                        : getCurrData.currencyName != null
                        ? getCurrData.currencyName
                        : getCurrData.currencySymbol}{' '}
                      {tableProductCommonData.supplyPrice != undefined
                        ? parseFloat(
                            tableProductCommonData.supplyPrice
                          ).toFixed(getDefaultDecimalPlaces)
                        : '0.00'}
                    </div>
                  </div>
                </Col>

                <Col md={12}></Col>
              </Row>
            </Col>

            <Col md={4}>
              <h4 class='custom-font-weight-500'>
                {' '}
                <IntlMessages id='products.main.listingtable.tags' />{' '}
              </h4>
              <div className='custom-display-flex custom-flex-wrap'>
                {tableProductCommonData.productTags &&
                tableProductCommonData.productTags.length &&
                tableProductCommonData.productTags[0].key != 0 ? (
                  tableProductCommonData.productTags.map(e => {
                    return <Tag color='blue'>{e.name}</Tag>
                  })
                ) : (
                  <Tag color='green'>
                    {' '}
                    <IntlMessages id='products.main.listingtable.notag' />
                  </Tag>
                )}
              </div>
            </Col>
          </Row>
        </>
      )
    }
  }

  function changeFilterStatus (val) {
    form.setFieldsValue({ ProductStatus: val })
  }

  //Main Return
  return getIsAllowRead ? (
    <div className='Content-wrapper Product-pg'>
      <Row className='align-items-center justify-content-center mb-3 Product-header'>
        <Col lg={6} md={6} sm={24} xs={24}>
          <h1 className='mb-0'>
            <IntlMessages id='products.main.add.products' />
          </h1>
        </Col>
        <Col lg={18} md={18} sm={24} xs={24}>
          <div className='pg-header-btn'>
            <Button
              className=''
              type='primary'
              onClick={redirectToImport}
              size='large'
              disabled={getIsDisableCreate}
            >
              <IntlMessages id='products.main.add.import' />
            </Button>
            <Button
              className='dk-btn-add'
              type='primary'
              onClick={redirectToadd}
              size='large'
              disabled={getIsDisableCreate}
            >
              <IntlMessages id='products.main.add.addproduct' />
            </Button>
          </div>
        </Col>
      </Row>

      <Card className='gx-card' title=''>
        <Collapse>
          <Panel
            className='custom-promolist-help'
            showArrow={false}
            header={
              <IntlMessages id='products.main.add.needhelpheadingproduct' />
            }
          >
            <Row>
              <div className='billing-main'>
                <Col className='custom-promolist-helpdesc' md={12}>
                  <p>
                    <IntlMessages id='products.main.add.needhelpheadingproductpdescription1' />
                  </p>
                  <p>
                    <IntlMessages id='products.main.add.needhelpheadingproductpdescription2' />
                  </p>
                  <p>
                    <IntlMessages
                      id='products.main.add.needhelpheadingproductpdescription3'
                      values={{
                        strong: chunks => <strong>{chunks}</strong>,
                        bus_name_first: REACT_APP_BUS_FIRST_NAME
                      }}
                    />
                  </p>
                </Col>

                <Col md={12}>
                  <img src={ProductImg} alt='' />
                </Col>
              </div>
            </Row>
          </Panel>
        </Collapse>
      </Card>

      <Card
        className='gx-card Filters-wrapper No-BoxShadow'
        title={<IntlMessages id='products.main.add.searchfilters' />}
      >
        <Form
          {...formItemLayout}
          form={form}
          name={'SearchForm'}
          // className="ant-advanced-search-form product-search-form" 18-07202
          className='ant-advanced-search-form Filters-Form'
          layout='horizontal'
          onFinish={onFinish}
          initialValues={{ ProductStatus: DefaultStatus }}
        >
          <>
            <Row>
              <Col
                xl={12}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className='filter-p-search'
              >
                <label>Search or Scan for products</label>
                <ProductSearch isLabel={false} />
              </Col>
              <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  className='ant-form-item-label-custom'
                  name='ProductType'
                  label={<IntlMessages id='products.main.add.producttype' />}
                >
                  <Select
                    placeholder={
                      <IntlMessages id='products.main.add.chooseproducttype' />
                    }
                    showSearch
                    optionFilterProp='children'
                    style={{ marginBottom: 12 }}
                  >
                    {productTypeOptions &&
                      productTypeOptions.map((e, key) => {
                        return <option value={e.id}>{e.label}</option>
                      })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  name='ProductTags'
                  className='ant-form-item-label-custom ant-form-margin-right'
                  label={
                    <IntlMessages id='products.main.listingtable.productags' />
                  }
                >
                  <Select
                    placeholder='Select multiple produt tags'
                    mode='multiple'
                    showSearch
                    optionFilterProp='children'
                    className='p-tags'
                  >
                    {productTagOptions &&
                      productTagOptions.map((e, key) => {
                        return <option value={e.id}>{e.label} </option>
                      })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right  '
                  name='SupplierID'
                  label={<IntlMessages id='products.main.add.supplier' />}
                >
                  <Select
                    placeholder={
                      <IntlMessages id='products.main.add.choosesupplier' />
                    }
                    showSearch
                    optionFilterProp='children'
                  >
                    {supplierOptions &&
                      supplierOptions.map((e, key) => {
                        return (
                          <option key={key} value={e.id}>
                            {e.label}
                          </option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Col>

              <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right  '
                  name='BrandID'
                  label={<IntlMessages id='products.main.add.brand' />}
                >
                  <Select
                    placeholder={
                      <IntlMessages id='products.main.add.choosebrand' />
                    }
                    showSearch
                    optionFilterProp='children'
                  >
                    {brandOptions &&
                      brandOptions.map((e, key) => {
                        return <option value={e.id}>{e.label}</option>
                      })}
                  </Select>
                </Form.Item>
              </Col>

              <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right  '
                  name='ProductStatus'
                  label={<IntlMessages id='products.listingtable.add.status' />}
                >
                  <Select
                    placeholder={
                      <IntlMessages id='products.listingtable.add.selectstatus' />
                    }
                  >
                    {/* <option value={2}>All Status</option> */}
                    <option value={1}>Active</option>
                    <option value={0}>InActive</option>
                  </Select>
                </Form.Item>
              </Col>

              <Col md={24} lg={24} sm={24} xs={24} className='dk-col-mb-search'>
                <div className='display-margin-unset'>
                  <Button
                    type='primary'
                    className='dk-btn-clear-field filter'
                    onClick={() => {
                      handleClearFields()
                    }}
                  >
                    <IntlMessages id='sell.salehistory.clear' />
                  </Button>
                  <Button className='' type='primary' htmlType='submit'>
                    <IntlMessages id='sell.salehistory.search' />
                  </Button>
                </div>
              </Col>
            </Row>
          </>
        </Form>
      </Card>

      <div className='gx-main-content-wrapper p-0 MinWidth-auto product-table'>
        {isLoading ? (
          <Skeleton count={5} height={30} />
        ) : (
          <>
            {form.getFieldValue('ProductStatus') == 0 &&
              getProductListingData &&
              getProductListingData.length > 0 &&
              !getProductListingData[0].isActive && (
                <div
                  style={{
                    background: '#ff000087',
                    color: 'white',
                    fontWeight: 'bold',
                    textAlign: 'center'
                  }}
                >
                  These Products are not active
                </div>
              )}
            <Table
              className='gx-table-responsive MinWidth-auto'
              columns={columns}
              dataSource={getProductListingData}
              rowKey={record => record.key}
              expandable={{
                expandedRowRender: (record, index) => (
                  <ExpandedRowRenderListing record={record} obj={index} />
                ),
                onExpand: (expanded, record) => {
                  if (expanded) {
                    getProductsDetailsRowData(expanded, record)
                    setExpandedRowKeys(record.key)
                  } else setExpandedRowKeys('')
                },

                rowExpandable: record => record.VariantName !== 'Not Expandable'
              }}
              expandedRowKeys={[expandedRowKeys]}
              pagination={pagination}
              onChange={handleTableChange}
              expandRowByClick
            />
          </>
        )}
      </div>
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default MainProduct
